<template>

  <v-card class="ob-filters">
    <slot v-if="!mobile"></slot>

    <ob-button-group>
      <slot name="controls" v-bind:options="{ mobile: mobile }"></slot>

      <v-btn :depressed="!mobile" v-if="mobile" @click="dialog = true">
        <font-awesome-icon icon="filter"/>
        {{ $t('shared.filters') }}
      </v-btn>

      <v-menu bottom left v-if="$scopedSlots && !!$scopedSlots.actions">
        <template v-slot:activator="{ on, attrs }">
          <v-btn :depressed="!mobile" v-bind="attrs" v-on="on">
            <font-awesome-icon icon="ellipsis-v"/>
            {{ $t('shared.actions') }}
          </v-btn>
        </template>

        <v-list>
          <slot name="actions"></slot>
        </v-list>
      </v-menu>
    </ob-button-group>

    <v-dialog v-model="dialog" v-if="mobile">
      <ob-dialog>
        <slot></slot>

        <template v-slot:actions>
          <v-btn text @click="close()">{{ $t('shared.close') }}</v-btn>
        </template>
      </ob-dialog>
    </v-dialog>
  </v-card>

</template>

<script>

  import ObDialog from './dialog'
  import ResponsiveIcon from './responsive-icon'
  import ObButtonGroup from './button-group'

  export default {
    name: 'ob-filters',

    data () {
      return {
        dialog: false
      }
    },

    computed: {
      mobile () {
        return this.$vuetify.breakpoint.smAndDown
      }
    },

    methods: {
      close () {
        this.dialog = false
        this.$emit('close')
      }
    },

    components: {
      ObButtonGroup,
      ResponsiveIcon,
      ObDialog
    }
  }
</script>

<style scoped lang="scss">

  @import '../../../assets/variables';
  @import '../../../assets/responsive';

  .ob-filters {
    display: flex;
    align-items: center;

    ::v-deep {
      .filters {
        display: flex;
        flex-basis: 100%;

        & > * {
          flex: 1 1 100%;
          //margin: 0;
          margin-right: $spacing-default;
        }
      }

      .ob-button-group {
        flex: 1 1 auto;
        flex-wrap: nowrap;
      }
    }

    @include media('<tablet') {
      background: none;
      border: none;
      box-shadow: none !important;
      margin-bottom: $spacing-small;
      padding: $spacing-default 0;

      .ob-button-group {
        flex-wrap: wrap;
      }
    }
  }

</style>
